module.exports = __webpack_public_path__ + "img/verify-email.bb02e952.svg";